import { Roulette } from '../../features/games/roulette/Roulette';
import { useGameConfig } from './gamePageHelpers';
import { Spinner } from '../../components/Spinner';

export function RoulettePage() {
  const { isLoading, enabled, minBet, maxBet } = useGameConfig('roulette');
  if (isLoading) return <Spinner full />;

  return (
    <div className="space-y-6">
      <h1 className="text-center text-3xl font-bold text-gold">🎡 Roulette</h1>
      {enabled ? (
        <Roulette minBet={minBet} maxBet={maxBet} />
      ) : (
        <p className="text-center text-slate-400">
          This game is currently unavailable.
        </p>
      )}
    </div>
  );
}
